import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import './Login.css';

const Login = () => {
  const [tab, setTab] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [registroExitoso, setRegistroExitoso] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [resetEnviado, setResetEnviado] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      if (error.message.includes('Email not confirmed')) {
        setError('Tenés que confirmar tu email antes de entrar. Revisá tu bandeja de entrada.');
      } else {
        setError(error.message);
      }
    }
    setLoading(false);
  };

  const iniciarCooldown = (segundos = 60) => {
    setCooldown(segundos);
    const t = setInterval(() => {
      setCooldown(prev => {
        if (prev <= 1) { clearInterval(t); return 0; }
        return prev - 1;
      });
    }, 1000);
  };

  const handleRegistro = async (e) => {
    e.preventDefault();
    setError('');
    if (cooldown > 0) return;
    if (!nickname.trim()) { setError('El nickname es obligatorio'); return; }
    if (nickname.trim().length < 3) { setError('Mínimo 3 caracteres'); return; }
    if (!/^[a-zA-Z0-9_]+$/.test(nickname.trim())) { setError('El nickname solo puede tener letras, números y guión bajo (sin espacios ni caracteres especiales)'); return; }
    if (password !== confirmPassword) { setError('Las contraseñas no coinciden'); return; }
    if (password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }

    setLoading(true);

    const { data: existente } = await supabase
      .from('perfiles').select('id').eq('nickname', nickname.trim()).maybeSingle();
    if (existente) { setError('Ese nickname ya está en uso, elegí otro'); setLoading(false); return; }

    const { error } = await supabase.auth.signUp({
      email, password,
      options: { data: { nickname: nickname.trim() } }
    });

    setLoading(false);

    if (error) {
      if (error.message.includes('rate limit') || error.status === 429) {
        setError('Demasiados intentos. Esperá unos minutos antes de volver a intentarlo.');
        iniciarCooldown(120);
      } else if (error.message.includes('already registered') || error.message.includes('User already registered')) {
        setError('Ya existe una cuenta con ese email. ¿Querés iniciar sesión?');
        setTimeout(() => { setTab('login'); setError(''); }, 2500);
      } else {
        setError(error.message);
      }
      return;
    }

    iniciarCooldown(60);
    setRegistroExitoso(true);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('Ingresá tu email'); return; }
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + '/',
    });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      setResetEnviado(true);
    }
  };

  // ── Pantalla post-registro ──
  if (registroExitoso) return (
    <div className="login-container">
      <div className="login-form" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>📬</div>
        <h2 style={{ color: '#00f2ff', margin: '0 0 12px' }}>Revisá tu email</h2>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: 1.6, margin: '0 0 20px' }}>
          Te mandamos un link de confirmación a<br/>
          <strong style={{ color: '#e2e8f0' }}>{email}</strong>
        </p>
        <p style={{ color: '#475569', fontSize: '0.8rem', margin: '0 0 24px' }}>
          Hacé click en el link del mail para activar tu cuenta y después volvé acá a iniciar sesión.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {cooldown > 0 && (
            <p style={{ color: '#475569', fontSize: '0.75rem', margin: 0 }}>
              Podés reenviar el mail en {cooldown}s
            </p>
          )}
          {cooldown === 0 && (
            <button onClick={async () => {
              iniciarCooldown(60);
              await supabase.auth.resend({ type: 'signup', email });
            }}
              style={{ background: 'transparent', color: '#00f2ff', border: '1px solid #00f2ff44', borderRadius: '8px', padding: '8px 20px', cursor: 'pointer', fontSize: '0.82rem' }}>
              Reenviar email de confirmación
            </button>
          )}
          <button onClick={() => { setRegistroExitoso(false); setTab('login'); }}
            style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 24px', fontWeight: 'bold', cursor: 'pointer' }}>
            Ir al login
          </button>
        </div>
      </div>
    </div>
  );

  // ── Pantalla reset enviado ──
  if (resetEnviado) return (
    <div className="login-container">
      <div className="login-form" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}></div>
        <h2 style={{ color: '#00f2ff', margin: '0 0 12px' }}>Revisá tu email</h2>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: 1.6, margin: '0 0 20px' }}>
          Te mandamos un link para restablecer tu contraseña a<br/>
          <strong style={{ color: '#e2e8f0' }}>{email}</strong>
        </p>
        <p style={{ color: '#475569', fontSize: '0.8rem', margin: '0 0 24px' }}>
          Hacé click en el link del mail y vas a poder elegir una nueva contraseña.
        </p>
        <button onClick={() => { setResetEnviado(false); setTab('login'); setError(''); }}
          style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 24px', fontWeight: 'bold', cursor: 'pointer' }}>
          Volver al login
        </button>
      </div>
    </div>
  );

  return (
    <div className="login-container">
      <div className="login-form">

        {/* Logo / título */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h1 style={{ color: '#00f2ff', margin: '0 0 4px', fontSize: '1.8rem', letterSpacing: '3px' }}>DTXI</h1>
          <p style={{ color: '#475569', margin: 0, fontSize: '0.8rem', letterSpacing: '1px' }}>Desafío Táctico</p>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', marginBottom: '24px', background: '#0a0f19', borderRadius: '8px', padding: '3px' }}>
          {['login', 'registro'].map(t => (
            <button key={t} onClick={() => { setTab(t); setError(''); setConfirmPassword(''); }}
              style={{
                flex: 1, padding: '8px', border: 'none', borderRadius: '6px', cursor: 'pointer',
                background: tab === t ? '#1e293b' : 'transparent',
                color: tab === t ? '#00f2ff' : '#475569',
                fontWeight: tab === t ? 'bold' : 'normal',
                fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '1px', transition: '0.2s',
              }}>
              {t === 'login' ? 'Iniciar sesión' : 'Registrarse'}
            </button>
          ))}
        </div>

        {/* ── Formulario olvidé contraseña ── */}
        {tab === 'reset' ? (
          <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <p style={{ color: '#94a3b8', fontSize: '0.85rem', margin: '0 0 4px', lineHeight: 1.5 }}>
              Ingresá tu email y te mandamos un link para restablecer tu contraseña.
            </p>
            <div>
              <label style={{ color: '#475569', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Email</label>
              <input type="email" placeholder="tu@email.com" value={email}
                onChange={e => setEmail(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>
            {error && (
              <p style={{ color: '#ff4444', fontSize: '0.8rem', margin: 0, padding: '8px 12px', background: '#ff444411', borderRadius: '6px', border: '1px solid #ff444433' }}>
                {error}
              </p>
            )}
            <button type="submit" disabled={loading}
              style={{ padding: '12px', background: loading ? '#1e293b' : '#00f2ff', color: loading ? '#475569' : '#000', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '0.9rem', cursor: loading ? 'default' : 'pointer', transition: '0.2s', marginTop: '4px' }}>
              {loading ? 'Enviando...' : 'Enviar link'}
            </button>
            <button type="button" onClick={() => { setTab('login'); setError(''); }}
              style={{ background: 'transparent', color: '#475569', border: 'none', fontSize: '0.8rem', cursor: 'pointer', padding: '4px' }}>
              ← Volver al login
            </button>
          </form>
        ) : (
          /* ── Formulario login / registro ── */
          <form onSubmit={tab === 'login' ? handleLogin : handleRegistro}
            style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

            {tab === 'registro' && (
              <div>
                <label style={{ color: '#475569', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>
                  Nickname
                </label>
                <input
                  type="text" placeholder="Tu nombre en el juego"
                  value={nickname} onChange={e => setNickname(e.target.value)}
                  maxLength={20}
                  style={{ width: '100%', padding: '10px 12px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }}
                />
                <p style={{ color: '#334155', fontSize: '0.68rem', margin: '4px 0 0' }}>
                  Único, visible para todos. No se puede cambiar.
                </p>
              </div>
            )}

            <div>
              <label style={{ color: '#475569', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Email</label>
              <input type="email" placeholder="tu@email.com" value={email}
                onChange={e => setEmail(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>

            <div>
              <label style={{ color: '#475569', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Contraseña</label>
              <input type="password" placeholder="••••••••" value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>

            {tab === 'registro' && (
              <div>
                <label style={{ color: '#475569', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Confirmá tu contraseña</label>
                <input type="password" placeholder="••••••••" value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', background: '#0a0f19', border: `1px solid ${confirmPassword && confirmPassword !== password ? '#ef4444' : '#1e293b'}`, borderRadius: '8px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }}
                />
                {confirmPassword && confirmPassword !== password && (
                  <p style={{ color: '#ef4444', fontSize: '0.68rem', margin: '4px 0 0' }}>Las contraseñas no coinciden</p>
                )}
                {confirmPassword && confirmPassword === password && (
                  <p style={{ color: '#22c55e', fontSize: '0.68rem', margin: '4px 0 0' }}>✓ Las contraseñas coinciden</p>
                )}
              </div>
            )}

            {error && (
              <p style={{ color: error.startsWith('✓') ? '#22c55e' : '#ff4444', fontSize: '0.8rem', margin: 0, padding: '8px 12px', background: error.startsWith('✓') ? '#22c55e11' : '#ff444411', borderRadius: '6px', border: `1px solid ${error.startsWith('✓') ? '#22c55e33' : '#ff444433'}` }}>
                {error}
              </p>
            )}

            <button type="submit" disabled={loading || (tab === 'registro' && cooldown > 0)}
              style={{ padding: '12px', background: (loading || (tab === 'registro' && cooldown > 0)) ? '#1e293b' : '#00f2ff', color: (loading || (tab === 'registro' && cooldown > 0)) ? '#475569' : '#000', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '0.9rem', cursor: (loading || (tab === 'registro' && cooldown > 0)) ? 'default' : 'pointer', transition: '0.2s', marginTop: '4px' }}>
              {loading ? 'Cargando...' : (tab === 'registro' && cooldown > 0) ? `Esperá ${cooldown}s...` : tab === 'login' ? 'Entrar' : 'Crear cuenta'}
            </button>

            {/* ── Link olvidé contraseña — solo en login ── */}
            {tab === 'login' && (
              <button type="button" onClick={() => { setTab('reset'); setError(''); }}
                style={{ background: 'transparent', color: '#475569', border: 'none', fontSize: '0.78rem', cursor: 'pointer', padding: '2px', textAlign: 'center' }}>
                ¿Olvidaste tu contraseña?
              </button>
            )}
          </form>
        )}

      </div>
    </div>
  );
};

export default Login;